import actions from "./actions";

const initState = {
  groups: [],
  users: [],
  configs: {
    schools: null,
    grades: null,
    subjects: null,
  },
  loading: false,
  completed: false,
  error: "",
  history: [],
  key: null,
  total: 0,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_GROUP_SUCCESS:
      return { ...state, completed: action.completed };

    case actions.FETCH_CONFIGS_SUCCESS:
      return {
        ...state,
        configs: {
          schools: action.schools,
          subjects: action.subjects,
          grades: action.grades,
        },
      };

    case actions.EDIT_GROUP_SUCCESS:
      return { ...state, completed: action.completed };

    case actions.LIST_GROUP_SUCCESS:
      return {
        ...state,
        groups: action.payload,
        completed: false,
        total: action.total,
      };

    case actions.FETCH_USERS_FOR_GROUP:
      return { ...state, users: [] };

    case actions.FETCH_USERS_FOR_GROUP_SUCCESS:
      return { ...state, users: action.payload };

    case actions.GET_CHAT_HISTORY:
      return { ...state, history: [] };

    case actions.GET_CHAT_HISTORY_SUCCESS:
      return { ...state, history: action.payload };

    case actions.SET_LOADING:
      return { ...state, loading: action.loading };

    case actions.SET_FILTER:
      return { ...state, key: action.key };

    case actions.RESET:
      return {
        ...state,
        surveys: [],
        subjects: [],
        grades: [],
        survey: null,
        assertionID: "",
      };

    default:
      return state;
  }
}
